import {
  SAVE_OBJ_MOVE_FAILURE,
  SAVE_OBJ_MOVE_SUCCESS,
  SAVE_OBJ_MOVE_REQUEST,
  FETCH_OBJ_MOVES_REQUEST,
  FETCH_OBJ_MOVES_SUCCESS,
  FETCH_OBJ_MOVES_FAILURE,
  FETCH_OBJ_MOVE_REQUEST,
  FETCH_OBJ_MOVE_SUCCESS,
  FETCH_OBJ_MOVE_FAILURE,
  DELETE_OBJ_MOVE_REQUEST,
  DELETE_OBJ_MOVE_SUCCESS,
  DELETE_OBJ_MOVE_FAILURE,
  FETCH_MAX_REPORT_ID_REQUEST,
  FETCH_MAX_REPORT_ID_SUCCESS,
  FETCH_MAX_REPORT_ID_FAILURE,
  FETCH_MOVEMENT_COMPLETE_REQUEST,
  FETCH_MOVEMENT_COMPLETE_SUCCESS,
  FETCH_MOVEMENT_COMPLETE_FAILURE,
} from './types';

const INITIAL_STATE = {
  objectMovements: [],
  objectMovement: null,
  objectMovementComplete: null,
  maxReportId: null,
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_OBJ_MOVES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_OBJ_MOVES_SUCCESS:
      return {
        ...state,
        loading: false,
        objectMovements: action.payload,
      };

    case FETCH_OBJ_MOVES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        objectMovements: [],
      };
    case FETCH_OBJ_MOVE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_OBJ_MOVE_SUCCESS:
      return {
        ...state,
        loading: false,
        objectMovement: action.payload,
      };

    case FETCH_OBJ_MOVE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        objectMovement: null,
      };
    case SAVE_OBJ_MOVE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SAVE_OBJ_MOVE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SAVE_OBJ_MOVE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case DELETE_OBJ_MOVE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_OBJ_MOVE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case DELETE_OBJ_MOVE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case FETCH_MAX_REPORT_ID_REQUEST:
      return {
        ...state,
        error: null,
      };

    case FETCH_MAX_REPORT_ID_SUCCESS:
      return {
        ...state,
        maxReportId: action.payload,
      };

    case FETCH_MAX_REPORT_ID_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        maxReportId: null,
      };
    case FETCH_MOVEMENT_COMPLETE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_MOVEMENT_COMPLETE_SUCCESS:
      return {
        ...state,
        loading: false,
        objectMovementComplete: action.payload,
      };

    case FETCH_MOVEMENT_COMPLETE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        objectMovementComplete: null,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
